module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-24@2x-34c7b193df79a3fa5c77db29e0f30de1.png";